import { nanoid } from 'nanoid';
import { useState } from 'react';

// hook to get/set idempotency key for payments
// generateNewIdempotencyKey is used whenever a change happens on the form
export const useGenerateIdempotencyKey = () => {
  const [idempotencyKey, setIdempotencyKey] = useState<string>(nanoid());

  const generateNewIdempotencyKey = () => {
    setIdempotencyKey(nanoid());
  };

  return {
    idempotencyKey,
    generateNewIdempotencyKey,
  };
};
